/* eslint-disable jsx-a11y/anchor-is-valid */
import { openWhatsApp } from "../../utils/whatsapp";

export default function Footer() {
  return (
    <footer className="sm-footer">
      <div className="sm-footer-inner">
        <div className="sm-footer-top">
          <div>
            <div className="sm-footer-brand">
              <span
                style={{
                  width: 6,
                  height: 6,
                  background: "var(--gold)",
                  borderRadius: "50%",
                  display: "inline-block",
                }}
              />
              Stock Move
            </div>

            <p className="sm-footer-desc">
              Inventory intelligence for apparel and retail stores. Turn sales
              and stock data into clear action — and recover blocked cash.
            </p>

            <button onClick={() => openWhatsApp()} className="sm-footer-cta">
              Book a Demo
            </button>
          </div>

          <div>
            <div className="sm-footer-col-title">Product</div>
            {["How It Works", "Features", "Results", "Pricing"].map((item) => (
              <a key={item} href="#" className="sm-footer-link">
                {item}
              </a>
            ))}
          </div>

          <div>
            <div className="sm-footer-col-title">Company</div>
            {["About", "Blog", "Contact", "Privacy Policy"].map((item) => (
              <a key={item} href="#" className="sm-footer-link">
                {item}
              </a>
            ))}
          </div>
        </div>

        <div className="sm-footer-bottom">
          <span className="sm-footer-copy">
            © 2025 Stock Move. All rights reserved.
          </span>
          <span
            className="sm-footer-copy"
            style={{ color: "rgba(247,244,238,.2)" }}
          >
            Built for Indian retail. Globally polished.
          </span>
        </div>
      </div>
    </footer>
  );
}